import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApisService } from '@core/services/apis.service';
import { LoadingService } from '@core/services/loading.service';
import { TranslateService } from '@ngx-translate/core';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-add-store-book',
  templateUrl: './add-store-book.component.html',
  styleUrls: ['./add-store-book.component.scss']
})
export class AddStoreBookComponent implements OnInit {
formData: any = {
  bookName: '',
  bookDescription: '',
  autherName: '',
  categoryId: null,
  subCategoryId: null,
  fileTypeId: '',
  imgFile: '',
  bookFile: '',
};
// Declare formData property 
    public arrCountries:any[] = [];
    public country:any[] = [];
      public currentPage = 1; 
  public categories : any
  public totalItems = 0;
subCategories: any[] = [];

  imagePreview: string | ArrayBuffer | null = null;
bookFileName: string | null = null;
    constructor(private router: Router, private apisService: ApisService,
        private route: ActivatedRoute,    private loading : LoadingService,
        private translate: TranslateService
    ) { }
  
    ngOnInit(): void {
          this.getMainCategories();

      // this.postCountires();
    const bookId = this.route.snapshot.paramMap.get('id');
  if (bookId) {
    this.fetchBookForEdit(+bookId);
  }
    }
    fetchBookForEdit(id: number): void {
  this.apisService.getBookById(id).subscribe({
    next: (book) => {
      this.formData.bookName = book.data.bookName;
      this.formData.bookDescription = book.data.bookDescription;
      this.formData.autherName = book.data.autherName;
      this.formData.fileTypeId = book.data.fileTypeId;
      this.formData.categoryId = book.data.categoryId;
      this.formData.subCategoryId = book.data.subCategoryId;
      this.formData.imgFile = book.data.imgFile;
      this.formData.bookFile = book.data.bookFile;
      this.imagePreview = book.data.imgURL;

      // Set preview image URL if needed
    },
    error: (err) => {
      console.error('Error fetching book:', err);
    },
  });
}

onCategoryChange(categoryId: number) {
  if (categoryId) {
    this.apisService.getMainSubCategories(categoryId).subscribe({
      next: (res) => {
        this.subCategories = res.data ? [res.data] : [];
      },
      error: (err) => {
        console.error('Error loading subcategories:', err);
        this.subCategories = [];
      }
    });
  }
}
 getMainCategories(){
      this.loading.show()
  this.apisService.getMainCategories(this.currentPage).subscribe((res: any) => {
    this.loading.hide()
    this.categories = res.data;
    this.totalItems = this.categories.length;
  })
 }

onMainCategoryChange() {

  if (this.formData.categoryId) {
    this.apisService.getMainSubCategories(this.formData.categoryId).subscribe((res: any) => {
      this.subCategories = res.data;
    });
    // Reset subcategory when category changes
    this.formData.subCategoryId = null;
  }
}

    cancel(): void {
      this.router.navigate(['/settings/countries']);
    }
  
    getTranslation(translations: any[], locale: string) {
      return translations.find(translation => translation.locale === locale) || {};
    }

  onFileSelected(event: Event, type: 'img' | 'book'): void {
  const input = event.target as HTMLInputElement;
  if (input.files && input.files.length > 0) {
    const file = input.files[0];
    if (type === 'img') {
      this.formData.imgFile = file;
    } else if (type === 'book') {
      this.formData.bookFile = file;
    }
  }
}



 submitForm(): void {
  const payload = {
    fileTypeId: this.formData.fileTypeId,
    bookName: this.formData.bookName,
    bookDescription: this.formData.bookDescription,
    categoryId: this.formData.categoryId,
    subCategoryId: this.formData.subCategoryId,
    autherName: this.formData.autherName,
    imgURL: this.formData.imgFile, // now just URL string
    bookURL: this.formData.bookFile // now just URL string
  };

  // const id = 1; 
  const id = this.route.snapshot.paramMap.get('id');

  this.loading.show(); // ✅ Show loading before API call


  this.apisService.addBookStore(+id, payload).subscribe({
    next: (res) => {

            this.loading.hide(); // ✅ Hide loading before showing alert


this.translate.get(['MENU.DASHBOARD.SUCCESS', 'MENU.DASHBOARD.BOOK_ADDED',  'MENU.DASHBOARD.OK'
]).subscribe(translations => {
  //  Swal.fire({
  //   title: translations['MENU.DASHBOARD.SUCCESS'],
  //   text: translations['MENU.DASHBOARD.BOOK_ADDED'],
  //   icon: 'success',
  //   confirmButtonText: translations['MENU.DASHBOARD.OK']
  // });

});
      this.router.navigate(['/book']);
    },
    
    error: (err) => {
            this.loading.hide(); // ✅ Hide loading before error alert

      console.error('Upload error:', err);
  
      const serverMessage = err?.error?.message || err?.message;
  
      this.translate.get([
        'MENU.DASHBOARD.ERROR',
        'MENU.DASHBOARD.UNEXPECTED_ERROR',
        'MENU.DASHBOARD.OK'
      ]).subscribe(translations => {
        Swal.fire({
          title: translations['MENU.DASHBOARD.ERROR'],
          text: serverMessage || translations['MENU.DASHBOARD.UNEXPECTED_ERROR'],
          icon: 'error',
          confirmButtonText: translations['MENU.DASHBOARD.OK']
        });
      });
    }
});}

}
